var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.menuOpen)?_c('div',{staticClass:"menu-open"},[_c('a',{staticClass:"menu-open__close size-small",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.$store.commit('closeMenu')}}},[_vm._v("Close")]),_vm._v(" "),_c('nav-items',{staticClass:"size-large",attrs:{"position":"top"},on:{"click":function($event){$event.preventDefault();_vm.$store.commit('closeMenu')}}})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61ee5181","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/top-menu.vue
// module id = 236
// module chunks = 1